angular.module('study.ecrd.field.queries').controller('GridRowQueriesController', [
    'CrfService',
    '$stateParams',
    'AccountManager',
    'StudyContext',
    'QueriesService',
    function(CrfService, $stateParams, AccountManager, StudyContext, QueriesService) {
        var vm = this;

        // Instancia del grid
        var gridInstance;

        // Las instancias de campo que pertenecen a la fila del grid
        var rowFields = [];

        // Las acciones tienen un selector con los campos de la fila, cuyo resultado se almacena en esta variable
        vm.selectedField = null;

        // Índices de las listas a las que pertenece el grid
        var listIndices = CrfService.getListIndices($stateParams);

        // Permisos generales, a.k.a routes
        vm.permission = {
            read: AccountManager.hasPermission('read records queries'),
            create: AccountManager.hasPermission('create records queries'),
            reply: AccountManager.hasPermission('reply records queries'),
            close: AccountManager.hasPermission('close records queries'),
        };

        // Permisos según el ámbito del registro que estamos viendo
        vm.context = {
            read: StudyContext.canWithQueries('read'),
            create: StudyContext.canWithQueries('create'),
            reply: StudyContext.canWithQueries('reply'),
            close: StudyContext.canWithQueries('close'),
        };

        // Lista de queries asociadas a alguno de los campos de la fila
        vm.queries = [];

        // Campos que permiten crear query: campos con valor (no RTF) y con permisos de edición sobre ellos
        vm.queryableFields = [];

        vm.expandedQueries = {};

        vm.toggleExpandQuery = function(queryId) {
            vm.expandedQueries[queryId] = !vm.expandedQueries[queryId];
        };
        vm.isExpanded = function(queryId) {
            return vm.expandedQueries[queryId];
        };

        vm.$onInit = function() {
            loadGridInstance();
        };

        function loadGridInstance() {
            gridInstance = CrfService.getField(vm.gridId);

            loadRowFields();
        }

        function loadRowFields() {
            rowFields = [];
            vm.queryableFields = [];

            angular.forEach(gridInstance.getCells()[vm.rowIndex], function(field, colIndex) {
                if (!field) {
                    return; // celda del grid vacía
                }

                rowFields.push(field);

                if (field.allowsValue() && CrfService.isElementAvailableToCurrentProfile(field.getId())) {
                    vm.queryableFields.push({
                        field: field,
                        id: field.getId(),
                        label: gridInstance.getColumns()[colIndex],
                        index: colIndex,
                    });
                }
            });

            loadQueries();
        }

        function loadQueries() {
            // Partiendo de los campos de la fila la lista debe quedar ordenada
            vm.queries = rowFields.reduce(function(acc, field) {
                return acc.concat(QueriesService.getFieldQueries(field.getId(), listIndices).map(function(query) {
                    query.column = field.getGridColumnName();

                    return query;
                }));
            }, []);
        }

        vm.createQuery = function() {
            if (!vm.selectedField) {
                return;
            }

            return QueriesService.createQuery(vm.selectedField, listIndices).then(loadQueries);
        };

        vm.replyQuery = function(query) {
            return QueriesService.replyQuery(query).then(loadQueries);
        };

        vm.closeQuery = function(query) {
            return QueriesService.closeQuery(query).then(loadQueries);
        };
    },
]);
